interface ErrorBoxProps {
  message: string
}

export default function ErrorBox(props: ErrorBoxProps) {
  const { message } = props

  return <p className="max-w-screen-md rounded bg-danger-500 bg-opacity-25 p-4 text-danger-500">{message}</p>
}
